const getCurrentTime = (offset = 0) => new Date().getTime() + offset;

export default getCurrentTime;



// WEBPACK FOOTER //
// ../utils/functions/get-current-time.js